/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import SINI_POLYGON_CONFIG from "./SINI_POLYGON_CONFIG";
import SINI_DOWNLOAD_UNIVERSAL from "./SINI_DOWNLOAD_UNIVERSAL";
import SINI_SURVEY_1_TABLE from "./SINI_SURVEY_1_TABLE";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/
import ICON_BACK from "../../Assets/jsx/ICON_BACK";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import colors_landzone from "../../Data/colors_landzone.json";

/*CONST*/

class SINI_LAND_FULL extends Component {
  state = {
    anchor: null,
    modal_layer_config: false,
    modal_download_landvalue: false,
    modal_download_landzone: false,
    modal_survey_1_full: false,
  };

  componentDidMount() {
    const { sini_v2_list, request_id_active, ai_parent_detail_list } =
      this.props.sini;
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );
    const { poi_survey_1_features, poi_property_2025 } = sini_object;
    if (poi_survey_1_features?.length > 0) {
      this.props.set_value_sini({
        key: "sini_map_show",
        value: ["poi_survey_1_features", "isochrone"],
      });
    }
    if (poi_property_2025?.length > 0) {
      this.props.set_value_sini({
        key: "sini_map_show",
        value: ["poi_property_2025", "isochrone"],
      });
    }
  }

  toggle_survey_1_full = () => {
    this.setState({
      modal_survey_1_full: !this.state.modal_survey_1_full,
    });
  };

  toggle_download_landvalue = (e) => {
    this.setState({
      modal_download_landvalue: !this.state.modal_download_landvalue,
    });
    if (e) {
      this.setState({ anchor: e.currentTarget });
    }
  };

  toggle_download_landzone = (e) => {
    this.setState({
      modal_download_landzone: !this.state.modal_download_landzone,
    });
    if (e) {
      this.setState({ anchor: e.currentTarget });
    }
  };

  toggle_layer_config = (e) => {
    this.setState({ modal_layer_config: !this.state.modal_layer_config });
    if (e) {
      this.setState({ anchor: e.currentTarget });
    }
  };

  toggle_sini_map_show = (item) => {
    let { sini_map_show } = this.props.sini;
    if (sini_map_show.includes(item)) {
      sini_map_show = sini_map_show.filter((element) => element !== item);
    } else {
      sini_map_show.push(item);
    }
    this.props.set_value_sini({
      key: "sini_map_show",
      value: sini_map_show,
    });
  };

  toggle_sini_map_show_array = (array) => {
    let { sini_map_show } = this.props.sini;
    if (sini_map_show.includes(array[0])) {
      sini_map_show = sini_map_show.filter(
        (element) => !array.includes(element)
      );
    } else {
      sini_map_show = [...sini_map_show, ...array];
    }
    this.props.set_value_sini({
      key: "sini_map_show",
      value: sini_map_show,
    });
  };

  on_set_sini_menu_active = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "",
    });
    this.props.set_value_sini({
      key: "sini_map_show",
      value: ["poi", "isochrone"],
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const {
      modal_layer_config,
      modal_download_landvalue,
      modal_download_landzone,
      anchor,
      modal_survey_1_full,
    } = this.state;

    //global props
    const {
      sini_v2_list,
      request_id_active,
      ai_parent_detail_list,
      sini_map_show,
      is_show_download_button,
    } = this.props.sini;
    const { loading_item_array } = this.props.loading_reducer;

    //content
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const is_loading_landvalue = loading_item_array.includes("landvalue");
    const is_loading_landzone = loading_item_array.includes("landzone");

    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );

    const { count_sewa, average_sewa, poi_survey_1_features } = sini_object;

    const landvalue_one = sini_object?.landvalue_one;
    const landzone_one = sini_object?.landzone_one;
    const landvalue_neighbor = sini_object?.landvalue_neighbor || [];
    const landzone_neighbor = sini_object?.landzone_neighbor || [];

    const modal_survey_1_full_content = modal_survey_1_full && (
      <Modal
        modalSize="large"
        isOpen={modal_survey_1_full}
        onClose={this.toggle_survey_1_full}
      >
        <div className="box-body" id="box-body">
          <SINI_SURVEY_1_TABLE />
        </div>
      </Modal>
    );

    /*
     "properties": {
    "color": "#1a8bc0",
    "opacity": 0.5,
    "fid": 3655,
    "NOMORZONA": "120",
    "TAHUN": "2021",
    "RANGE_HRG": "< 100.000",
    "HARGA": "0",
    "HARGARATA2": "120",
    "KELASNILAI": "1"
  }
    */

    let content;
    if (
      is_loading_landvalue ||
      landvalue_one !== undefined ||
      landzone_one !== undefined ||
      poi_survey_1_features?.length > 0
    ) {
      const landvalue_value = landvalue_one?.properties?.["HARGA"];
      const landzone_value = landzone_one?.properties?.["GUNATANAH"];

      const is_landvalue_empty =
        landvalue_value === undefined && landvalue_neighbor.length === 0;

      const is_landzone_empty =
        !landzone_value ||
        landzone_value === undefined ||
        landzone_value === "undefined" ||
        landzone_neighbor.length === 0;

      let landvalue_content;
      let poi_survey_1_features_content;

      if (poi_survey_1_features?.length > 0) {
        poi_survey_1_features_content = (
          <table>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top" }}>
                  <button
                    className={
                      sini_map_show.includes("poi_survey_1_features")
                        ? "checklist_active"
                        : "checklist_not"
                    }
                    onClick={this.toggle_sini_map_show.bind(
                      this,
                      "poi_survey_1_features"
                    )}
                  />
                </td>
                <td>
                  <section className="margin_bottom">
                    <p className="text_small">
                      {dict?.["Amount of data"]?.[language]}
                    </p>
                    <div className="text_bold">{count_sewa}</div>
                  </section>
                  <section className="margin_bottom">
                    <p className="text_small">
                      {
                        dict?.[
                          "Average rental price based on survey results"
                        ]?.[language]
                      }
                    </p>
                    <div className="text_bold">
                      Rp.
                      {new Intl.NumberFormat("id-ID", {
                        style: "decimal",
                      }).format(average_sewa)}{" "}
                      /{dict?.["years"]?.[language]}
                    </div>
                  </section>
                  <button
                    className="button_big button_white outline_black"
                    onClick={this.toggle_survey_1_full}
                  >
                    {dict?.["View survey data details"]?.[language]}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        );
      }

      if (is_loading_landvalue) {
        landvalue_content = (
          <>
            <p className="text_small">{dict?.["Loading"]?.[language]}...</p>
            <br />
          </>
        );
      } else if (is_landvalue_empty) {
        landvalue_content = (
          <section className="margin_bottom">
            <p className="text_small">{dict?.["No data"]?.[language]}</p>
          </section>
        );
      } else {
        landvalue_content = (
          <main>
            <table>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top" }}>
                    <button
                      className={
                        sini_map_show.includes("landvalue")
                          ? "checklist_active"
                          : "checklist_not"
                      }
                      onClick={this.toggle_sini_map_show_array.bind(this, [
                        "landvalue",
                        "landvalue_neighbor",
                      ])}
                    />
                  </td>
                  <td>
                    <section className="margin_bottom">
                      <p className="text_small">
                        {dict?.["Land value estimation"]?.[language]}
                      </p>
                      <div>
                        <span className="text_bold margin_right">
                          Rp
                          {new Intl.NumberFormat("id-ID", {
                            style: "decimal",
                          }).format(parseInt(landvalue_value))}
                        </span>
                        <p className="text_small">
                          (per m<sup>2</sup>)
                        </p>
                      </div>
                    </section>
                    <section className="margin_bottom">
                      <p className="text_small margin_right">
                        {dict?.["Data around the point"]?.[language]}
                      </p>
                      <p className="text_bold">
                        {landvalue_neighbor?.length || 0} area
                      </p>
                    </section>
                  </td>
                </tr>
              </tbody>
            </table>
            {is_show_download_button && (
              <button
                className="badge background_grey_light margin_bottom"
                onClick={this.toggle_download_landvalue}
              >
                {dict?.["Download"]?.[language]}
              </button>
            )}
          </main>
        );
      }

      let landzone_content;
      if (is_loading_landzone || is_loading_landvalue) {
        landzone_content = (
          <>
            <p className="text_small">{dict?.["Loading"]?.[language]}...</p>
            <br />
          </>
        );
      } else if (!is_landzone_empty) {
        landzone_content = (
          <main>
            <table>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top" }}>
                    <button
                      className={
                        sini_map_show.includes("landzone")
                          ? "checklist_active"
                          : "checklist_not"
                      }
                      onClick={this.toggle_sini_map_show_array.bind(this, [
                        "landzone",
                        "landzone_neighbor",
                      ])}
                    />
                  </td>
                  <td>
                    <section className="margin_bottom">
                      <p className="text_small">
                        {dict?.["Land use"]?.[language]}
                      </p>
                      <div>
                        <span className="text_bold">{landzone_value}</span>
                      </div>
                    </section>
                    <section className="margin_bottom">
                      <p className="text_small margin_right">
                        {dict?.["Data around the point"]?.[language]}
                      </p>
                      <p className="text_bold">
                        {landzone_neighbor?.length || 0} area
                      </p>
                    </section>
                  </td>
                </tr>
              </tbody>
            </table>
            {is_show_download_button && (
              <button
                className="badge background_grey_light margin_bottom"
                onClick={this.toggle_download_landzone}
              >
                {dict?.["Download"]?.[language]}
              </button>
            )}
          </main>
        );
      } else {
        landzone_content = (
          <section className="margin_bottom">
            <p className="text_small">{dict?.["No data"]?.[language]}</p>
          </section>
        );
      }

      content = (
        <main>
          {poi_survey_1_features?.length > 0 && (
            <section className="container_light margin_bottom outline_grey">
              {poi_survey_1_features_content}
            </section>
          )}

          <section className="container_light margin_bottom outline_grey">
            {landvalue_content}
          </section>
          <section className="container_light margin_bottom outline_grey">
            {landzone_content}
          </section>
        </main>
      );
    }

    const legend_content = (
      <main className="container_light outline_grey">
        <p className="text_bold margin_bottom">
          {dict?.["Legend"]?.[language]}
        </p>
        <button
          className="button_big margin_bottom button_white outline_black"
          onClick={this.toggle_layer_config}
        >
          {dict?.["Edit info on map"]?.[language]}
        </button>
        <br />
        <table className="text_small">
          <tbody>
            {colors_landzone.map((item, idx) => {
              return (
                <tr key={idx}>
                  <td>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "5px",
                        backgroundColor: item.color,
                      }}
                    />
                  </td>
                  <td>{item.name}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
    );

    const modal_layer_config_content = (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_layer_config}
        onClose={this.toggle_layer_config}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <div
          style={{
            width: "250px",
          }}
        >
          <SINI_POLYGON_CONFIG />
        </div>
      </FLOAT_MENU>
    );

    const modal_download_landvalue_content = (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_download_landvalue}
        onClose={this.toggle_download_landvalue}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <div
          style={{
            width: "250px",
          }}
        >
          <SINI_DOWNLOAD_UNIVERSAL download_topic="landvalue_one" />
        </div>
      </FLOAT_MENU>
    );

    const modal_download_landzone_content = (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_download_landzone}
        onClose={this.toggle_download_landzone}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <div
          style={{
            width: "250px",
          }}
        >
          <SINI_DOWNLOAD_UNIVERSAL download_topic="landzone_one" />
        </div>
      </FLOAT_MENU>
    );

    return (
      <main className="sini_full_parent">
        {modal_survey_1_full_content}
        {modal_layer_config_content}
        {modal_download_landvalue_content}
        {modal_download_landzone_content}

        <section className="sini_full_header">
          <table>
            <tbody>
              <tr>
                <td
                  style={{ width: "30px" }}
                  onClick={this.on_set_sini_menu_active}
                  data-mapid="clickBack"
                >
                  <ICON_BACK />
                </td>
                <td className="text_left">
                  <div className="badge background_grey_light margin_bottom">
                    {dict?.["Land value and use"]?.[language]}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <br />
        <section className="sini_full_scroll_area">
          {content}
          {legend_content}
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, { set_value_sini })(SINI_LAND_FULL);
